export const generatedScenarioComparisonBoard = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-scenario-comparison-board",
  "operatingRule": "The comparison board freezes every scenario row with decision score, uncertainty budget, economics, traceability, blockers, and export hashes for reviewer and customer-package inspection.",
  "scenarioCount": 6,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "selectedScenarioId": "moon-first",
  "selectedScenarioName": "Moon-first Bootstrap",
  "exportManifest": {
    "csvPath": "public/scenario-comparison-board.csv",
    "markdownPath": "public/scenario-comparison-board.md",
    "csvHash": "sha256-cecffa188f8d5bbebd2d9bbb154686387cfd2b9fc9456c87f5de2e54eab02266",
    "markdownHash": "sha256-868546f68bf68e815c22bc7742b29083171535c4c9226004e682eb5583180b02",
    "deliveryBoundary": "Exports are for internal review, paid-beta scoping, and reproducibility only until source-use, runtime, economics, materials, resource, workspace, UI, and reviewer gates pass."
  },
  "evidenceHashes": {
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1"
  },
  "rows": [
    {
      "rank": 1,
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "decisionLane": "lane-2-conditional-diligence",
      "decisionReadinessScore": 62.91,
      "deterministicUtility": 67.12,
      "utilityP10": 65.53,
      "utilityMedian": 67.34,
      "utilityP90": 68.89,
      "uncertaintyBudgetPoints": 29.81,
      "uncertaintyClass": "managed-beta-uncertainty",
      "businessReadinessMedian": 76.65,
      "winProbabilityPercent": 75.78,
      "medianProgramNeedBn": 49.36,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 33.33,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1",
      "paretoFrontierMember": true,
      "requiredUtilityDeltaToLead": 0,
      "topCrossoverLever": "current-leader",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "optionality:76; resourceConfidence:74; processFit:70",
      "topRiskDrivers": "thermal:43.2; feedstock:42; processMaturity:30.4",
      "topUncertaintyDrivers": "model-spread:7.99; runtime-sidecar:6.5; assumption-sensitivity:6.44; source-use-rights:6.13",
      "topBlockers": "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.; Asteroid/resource candidates are not promoted for resource claims.; Claim claim-helium3: blocked-for-commercial-proof",
      "evidenceRefs": {
        "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c",
        "uncertaintyBudgetHash": "sha256-7500ba6f2d84d04fb1ca29f147b51a1837dea22ff94c58685f367d997e50a621",
        "traceHash": "sha256-4c9d51ef9294289600bc39fd2b99a03df6edf38557eb137e1a48a9bf1b0d3110"
      },
      "comparisonHash": "sha256-0e20a4f32e1fffc791e70ee9d42ae561995b00859acf3c54885589cc755b07b5"
    },
    {
      "rank": 2,
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "decisionLane": "lane-3-watchlist",
      "decisionReadinessScore": 59.78,
      "deterministicUtility": 65.69,
      "utilityP10": 63.58,
      "utilityMedian": 65.8,
      "utilityP90": 67.74,
      "uncertaintyBudgetPoints": 43.88,
      "uncertaintyClass": "medium-uncertainty",
      "businessReadinessMedian": 72.59,
      "winProbabilityPercent": 24.22,
      "medianProgramNeedBn": 61.38,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 40,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1; tudat-transfer-v1",
      "paretoFrontierMember": false,
      "requiredUtilityDeltaToLead": 1.43,
      "topCrossoverLever": "uncertainty-reduction:uncertaintyPenalty:3.4",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "optionality:92; energy:82; processFit:82",
      "topRiskDrivers": "feedstock:55; transport:46; thermal:40.5",
      "topUncertaintyDrivers": "model-spread:10.68; assumption-sensitivity:9.66; resource-evidence:9.5; runtime-sidecar:6.5",
      "topBlockers": "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Asteroid/resource candidates are not promoted for resource claims.",
      "evidenceRefs": {
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803",
        "uncertaintyBudgetHash": "sha256-d595ef57fc29b1e7bf00950455c56c83e9f708dd12dd6c63c2d8c22b72a89869",
        "traceHash": "sha256-d733f88bb38e404138d4ac8f6cca29c216f96ef4cfab8d1feb018406ef47b92d"
      },
      "comparisonHash": "sha256-c765fca1e18763bf995923b987883f1e0df592a1e5fd6009a0036b99492bbba0"
    },
    {
      "rank": 3,
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.63,
      "deterministicUtility": 51.37,
      "utilityP10": 48.51,
      "utilityMedian": 51.07,
      "utilityP90": 54.39,
      "uncertaintyBudgetPoints": 62.38,
      "uncertaintyClass": "high-uncertainty",
      "businessReadinessMedian": 59.76,
      "winProbabilityPercent": 0,
      "medianProgramNeedBn": 70,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 0,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1; tudat-transfer-v1",
      "paretoFrontierMember": false,
      "requiredUtilityDeltaToLead": 15.75,
      "topCrossoverLever": "uncertainty-reduction:uncertaintyPenalty:37.5",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "optionality:84; processFit:75; vacuum:63.75",
      "topRiskDrivers": "feedstock:72; transport:58; processMaturity:44",
      "topUncertaintyDrivers": "model-spread:15.7; runtime-sidecar:12; resource-evidence:11.2; assumption-sensitivity:10.74",
      "topBlockers": "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Asteroid/resource candidates are not promoted for resource claims.",
      "evidenceRefs": {
        "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051",
        "uncertaintyBudgetHash": "sha256-aeeeb361235a90a7df3c4136154cb8901a3573712450f7d0879a212ebf0fe17a",
        "traceHash": "sha256-d619bbef18fc804057f0cf68a6279068db56356135bf425e70958c3f1b2b904b"
      },
      "comparisonHash": "sha256-84608e1ed73d3da4c7c87c790bed8b11dd803804546ddad327dc99882b646aef"
    },
    {
      "rank": 4,
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 44.15,
      "deterministicUtility": 42.95,
      "utilityP10": 38.9,
      "utilityMedian": 42.78,
      "utilityP90": 46.63,
      "uncertaintyBudgetPoints": 65.61,
      "uncertaintyClass": "high-uncertainty",
      "businessReadinessMedian": 55.33,
      "winProbabilityPercent": 0,
      "medianProgramNeedBn": 97.54,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 40,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1; tudat-transfer-v1",
      "paretoFrontierMember": false,
      "requiredUtilityDeltaToLead": 24.17,
      "topCrossoverLever": "uncertainty-reduction:uncertaintyPenalty:57.55",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "energy:97; optionality:86; processFit:84",
      "topRiskDrivers": "transport:86; thermal:73.8; feedstock:70",
      "topUncertaintyDrivers": "model-spread:16; runtime-sidecar:12; assumption-sensitivity:11.82; resource-evidence:11",
      "topBlockers": "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Asteroid/resource candidates are not promoted for resource claims.",
      "evidenceRefs": {
        "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
        "uncertaintyBudgetHash": "sha256-70c464f33b48019386facb39aa0bfb479741a7cbb3dfba4dda52f3293de0512a",
        "traceHash": "sha256-347c3c0291493190d1eaba179b7e37c09366c6c992e8e7a322640eee5bd05757"
      },
      "comparisonHash": "sha256-8193cf633a9652086e465ca272495519c9ca24c4aac0c1911fa94631105ef6e4"
    },
    {
      "rank": 5,
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.72,
      "deterministicUtility": 40.78,
      "utilityP10": 38.16,
      "utilityMedian": 40.96,
      "utilityP90": 43.65,
      "uncertaintyBudgetPoints": 44.69,
      "uncertaintyClass": "medium-uncertainty",
      "businessReadinessMedian": 63.22,
      "winProbabilityPercent": 0,
      "medianProgramNeedBn": 68.05,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 0,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1; tudat-transfer-v1",
      "paretoFrontierMember": false,
      "requiredUtilityDeltaToLead": 26.34,
      "topCrossoverLever": "uncertainty-reduction:uncertaintyPenalty:62.71",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "optionality:65; resourceConfidence:65; processFit:46",
      "topRiskDrivers": "transport:62; comms:51.2; thermal:50.4",
      "topUncertaintyDrivers": "runtime-sidecar:12; model-spread:10.99; assumption-sensitivity:7.16; source-use-rights:6.13",
      "topBlockers": "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.; Asteroid/resource candidates are not promoted for resource claims.; Claim claim-helium3: blocked-for-commercial-proof",
      "evidenceRefs": {
        "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb",
        "uncertaintyBudgetHash": "sha256-48d87d02b127f7fc2148ebb78c5d2cef3929bf3650408bb38914aa658a5dd173",
        "traceHash": "sha256-fd5108fc370a65f836309389af914613680a45a2f8d2cd12b9f04f65a9a39068"
      },
      "comparisonHash": "sha256-faa7e78f6843f4bd8737baf17138a8c33fa941b37102e8c16771079ccb0b77d7"
    },
    {
      "rank": 6,
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.42,
      "deterministicUtility": 37.95,
      "utilityP10": 33.71,
      "utilityMedian": 37.84,
      "utilityP90": 41.82,
      "uncertaintyBudgetPoints": 64.95,
      "uncertaintyClass": "high-uncertainty",
      "businessReadinessMedian": 53.68,
      "winProbabilityPercent": 0,
      "medianProgramNeedBn": 104.1,
      "medianCapitalGapBn": 0,
      "runtimeEvidenceState": "blocked-scenario-runtime-contract-gaps",
      "runtimeEvidenceCoveragePercent": 40,
      "runtimeBlockedContracts": "orekit-propagation-v1; gmat-transfer-v1; tudat-transfer-v1",
      "paretoFrontierMember": false,
      "requiredUtilityDeltaToLead": 29.17,
      "topCrossoverLever": "uncertainty-reduction:uncertaintyPenalty:69.45",
      "promotionState": "blocked-for-commercial-proof",
      "commercializationAllowed": false,
      "topBenefitDrivers": "energy:88; optionality:80; processFit:74",
      "topRiskDrivers": "transport:90; thermal:79.2; comms:65.6",
      "topUncertaintyDrivers": "model-spread:16; assumption-sensitivity:12.18; runtime-sidecar:12; resource-evidence:10.4",
      "topBlockers": "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.; Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.; Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.; Asteroid/resource candidates are not promoted for resource claims.",
      "evidenceRefs": {
        "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934",
        "uncertaintyBudgetHash": "sha256-6557cf089ad444fcf5ed0be5797ebfedf1cac7d3b4976f5e92033b629b50e386",
        "traceHash": "sha256-5ab13dfa8e8a9fd561a2ee8af012a052ebd58a668b19dda311f91f6532036ecf"
      },
      "comparisonHash": "sha256-babeb6d242c117865b431a9a614d7e520e7a9504dc0bb2438273e5329cdbfa2d"
    }
  ],
  "boardHash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48"
}
;
